import { render, staticRenderFns } from "./EditModal.vue?vue&type=template&id=4125816c&scoped=true"
import script from "./EditModal.vue?vue&type=script&lang=js"
export * from "./EditModal.vue?vue&type=script&lang=js"
import style0 from "./EditModal.vue?vue&type=style&index=0&id=4125816c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4125816c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4125816c')) {
      api.createRecord('4125816c', component.options)
    } else {
      api.reload('4125816c', component.options)
    }
    module.hot.accept("./EditModal.vue?vue&type=template&id=4125816c&scoped=true", function () {
      api.rerender('4125816c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/component/EditModal.vue"
export default component.exports